import { atom } from 'jotai'
import {eventType, templateType, templateValuesType} from "@/lib/definitions/definitions";

export const templatesState = atom<templateValuesType[]>([]);
